module.exports = __webpack_public_path__ + "img/banner.0aa0e616.jpg";